import { Routes } from '@angular/router';

import { DeviceFlow } from './components/device/device-flow/device-flow';
import { DeviceModel } from './components/device/device-model/device-model';
import { DeviceRegister } from './components/device/device-register/device-register';
import { DeviceType } from './components/device/device-type/device-type';
import { Permission } from './models/user';
import { rolePermissionGuard } from './utilities/guards/role-permission-guard';

export const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
        path: '',
        loadComponent: () => import('./components/leading/leading').then((c) => c.Leading),
        children: [
            {
                path: 'dashboard',
                loadComponent: () => import('./components/dashboard/dashboard').then((c) => c.Dashboard),
                data: { title: 'Homepage' }
            },
            {
                path: 'device',
                loadComponent: () => import('./components/device/device').then((c) => c.Device),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Apparati',
                    rolePermission: [Permission.apparatoRead, Permission.utenzaRead, Permission.utenzaWrite, Permission.apparatoassetmodelflowRead, Permission.apparatoassetmodelflowWrite, Permission.apparatoassetmodelRead, Permission.apparatoassetmodelWrite, Permission.apparatoassettypeRead, Permission.apparatoassettypeWrite]

                },
                children: [
                    { path: '', redirectTo: 'register', pathMatch: 'full' },
                    {
                        path: 'register',
                        loadComponent: () => import('./components/device/device-register/device-register').then((c) => DeviceRegister),
                        data: {
                            title: 'Apparati',
                            rolePermission: [Permission.apparatoRead]

                        }
                    },
                    {
                        path: 'type',
                        loadComponent: () => import('./components/device/device-type/device-type').then((c) => DeviceType),
                        data: {
                            title: 'Apparati',
                            rolePermission: [Permission.apparatoassettypeRead, Permission.apparatoassettypeWrite]

                        }
                    },
                    {
                        path: 'model',
                        loadComponent: () => import('./components/device/device-model/device-model').then((c) => DeviceModel),
                        data: {
                            title: 'Apparati',
                            rolePermission: [Permission.apparatoassetmodelRead, Permission.apparatoassetmodelWrite]

                        }
                    },
                    {
                        path: 'flow',
                        loadComponent: () => import('./components/device/device-flow/device-flow').then((c) => DeviceFlow),
                        data: {
                            title: 'Apparati',
                            rolePermission: [Permission.apparatoassetmodelflowRead, Permission.apparatoassetmodelflowWrite]

                        }
                    }
                ]
            },
            {
                path: 'device/:imei',
                loadComponent: () => import('./components/device/device-info/device-info').then((c) => c.DeviceInfo),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Dettaglio Terminale',
                    rolePermission: [Permission.apparatoRead]
                }
            },
            {
                path: 'utilities',
                loadComponent: () => import('./components/sim-cards/sim-cards').then((c) => c.SimCards),
                data: {
                    title: 'Utenze',
                    rolePermission: [Permission.utenzaRead, Permission.utenzaWrite]
                }
            },
            {
                path: 'sim-users',
                loadComponent: () => import('./components/sim-users/sim-users').then((c) => c.SimUsers),
                data: {
                    title: 'Utilizzatori',
                    rolePermission: [Permission.customerRead, Permission.customerWrite]
                }
            },
            {
                path: 'user',
                loadComponent: () => import('./components/user/user').then((c) => c.User),
                data: {
                    title: 'Utenti',
                    rolePermission: [Permission.portaluserRead, Permission.portaluserWrite]
                }
            },
            {
                path: 'consumption',
                loadComponent: () => import('./components/consumption/consumption').then((c) => c.Consumption),
                data: { title: 'Consumi' }
            },
            {
                path: 'aggregates',
                loadComponent: () => import('./components/report/report-aggregates/report-aggregates').then((c) => c.ReportAggregates),
                data: { title: 'Aggregati' }
            },
            {
                path: 'director',
                loadComponent: () => import('./components/report/report-director/report-director').then((c) => c.ReportDirector),
                data: { title: 'Direttrice' }
            },
            {
                path: 'monthly',
                loadComponent: () => import('./components/report/report-monthly/report-monthly').then((c) => c.ReportMonthly),
                data: { title: 'Mensile' }
            },
            {
                path: 'recursion',
                loadComponent: () => import('./components/report/report-recursion/report-recursion').then((c) => c.ReportRecursion),
                data: { title: 'Ricorsioni' }
            },
            {
                path: 'top-consumer',
                loadComponent: () => import('./components/report/report-top-consumer/report-top-consumer').then((c) => c.ReportTopConsumer),
                data: { title: 'Top Consumer' }
            },
            {
                path: 'roaming',
                loadComponent: () => import('./components/report/report-roaming/report-roaming').then((c) => c.ReportRoaming),
                data: { title: 'Gettoni Roaming' }
            },
            {
                path: 'director-group',
                loadComponent: () => import('./components/report/report-director-group/report-director-group').then((c) => c.ReportDirectorGroup),
                data: { title: 'Gruppo Direttrice' }
            },
            {
                path: 'invoice',
                loadComponent: () => import('./components/invoice/invoice').then((c) => c.Invoice),
                data: { title: 'Fatture' }
            },
            {
                path: 'contract',
                loadComponent: () => import('./components/contract/contract').then((c) => c.Contract),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Contratti',
                    rolePermission: [Permission.contrattoRead, Permission.contrattoWrite]
                }
            },
            {
                path: 'customer',
                loadComponent: () => import('./components/customer/customer').then((c) => c.Customer),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Clienti',
                    rolePermission: [Permission.aziendaRead, Permission.aziendaWrite]
                }
            },
            {
                path: 'assistance',
                loadComponent: () => import('./components/assistance/assistance').then((c) => c.Assistance),
                data: { title: 'Assistenza' }
            },
            {
                path: 'auditlog',
                loadComponent: () => import('./components/auditlog/auditlog').then((c) => c.Auditlog),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Audit Log',
                    rolePermission: [Permission.autilogRead]
                }
            },
            {
                path: 'job-history',
                loadComponent: () => import('./components/job-history/job-history').then((c) => c.JobHistory),
                canActivate: [rolePermissionGuard],
                data: {
                    title: 'Job History',
                    rolePermission: [Permission.jobHistoryRead]
                }
            }
        ]
    }
];
